import {NgOption} from '@ng-select/ng-select';

export interface NgOptionCustom extends NgOption {
  isUniqueSelection?: boolean;
  isRemove?: boolean;
  value?: any;
}

export type SelectionModelFactory = () => SelectionModel;

export function CustomSelectionModelFactory() {
  return new CustomSelectionModel();
}


export interface SelectionModel {
  value: NgOptionCustom[];

  select(item: NgOptionCustom, multiple: boolean, selectableGroupAsModel: boolean);

  unselect(item: NgOptionCustom, multiple: boolean);

  clear(keepDisabled: boolean);
}

export class CustomSelectionModel implements SelectionModel {
  // tslint:disable-next-line:variable-name
  private _selected: NgOptionCustom[] = [];

  get value(): NgOptionCustom[] {
    return this._selected;
  }

  public scRelatedDocumentComponent: any;
  select(item: NgOptionCustom, multiple: boolean, groupAsModel: boolean) {
    item.selected = item.value.uniqueSelection ? item.value.uniqueSelection : false;

    if (!item.children || (!multiple && groupAsModel)) {
      this._selected.push(item);
    }
    if (multiple) {
      if (item.parent) {
        const childrenCount = item.parent.children.length;
        const selectedCount = item.parent.children.filter(x => x.selected).length;
        item.parent.selected = childrenCount === selectedCount;
      } else if (item.children) {
        this._setChildrenSelectedState(item.children, true);
        this._removeChildren(item);
        if (groupAsModel && this._activeChildren(item)) {
          this._selected = [...this._selected.filter(x => x.parent !== item), item];
        } else {
          this._selected = [...this._selected, ...item.children.filter(x => !x.disabled)];
        }
      }
    }
    if (this.scRelatedDocumentComponent) {
      this.scRelatedDocumentComponent.cd.markForCheck();
    }
  }


  customUnselect(item: NgOptionCustom, multiple: boolean, itemIndex: number, ngSelect) {

    setTimeout(() => {
      this._selected = this._selected.filter((elem, index) => index !== itemIndex);
      if (multiple) {
        if (item.parent && item.parent.selected) {
          const children = item.parent.children;
          this._removeParent(item.parent);
          this._removeChildren(item.parent);
          this._selected.push(...children.filter(x => x !== item && !x.disabled));
          item.parent.selected = false;
        } else if (item.children) {
          this._setChildrenSelectedState(item.children, false);
          this._removeChildren(item);
        }
      }

      ngSelect.detectChanges();
      ngSelect._cd.detectChanges();
      if (this.scRelatedDocumentComponent) {
        this.scRelatedDocumentComponent.cd.markForCheck();
      }
   });
  }

  unselect(item: NgOptionCustom, multiple: boolean) {
    this._selected = this._selected.filter(x => x !== item);
    item.selected = false;
    if (multiple) {
      if (item.parent && item.parent.selected) {
        const children = item.parent.children;
        this._removeParent(item.parent);
        this._removeChildren(item.parent);
        this._selected.push(...children.filter(x => x !== item && !x.disabled));
        item.parent.selected = false;
      } else if (item.children) {
        this._setChildrenSelectedState(item.children, false);
        this._removeChildren(item);
      }
    }
  }

  customRemove(item: NgOptionCustom) {
    this._selected = this._selected.filter(x => x !== item);
  }

  clear(keepDisabled: boolean) {
    // console.log('custom clear triggered', keepDisabled, this);
    this._selected = keepDisabled ? this._selected.filter(x => x.disabled) : [];
  }

  private _setChildrenSelectedState(children: NgOptionCustom[], selected: boolean) {
    for (const child of children) {
      if (child.disabled) {
        continue;
      }
      child.selected = selected;
    }
  }

  private _removeChildren(parent: NgOptionCustom) {
    this._selected = [
      ...this._selected.filter(x => x.parent !== parent),
      ...parent.children.filter(x => x.parent === parent && x.disabled && x.selected)
    ];
  }

  private _removeParent(parent: NgOptionCustom) {
    this._selected = this._selected.filter(x => x !== parent);
  }

  private _activeChildren(item: NgOptionCustom): boolean {
    return item.children.every(x => !x.disabled || x.selected);
  }
}
